import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import SelectSearch from "react-select-search";
import moment from "moment";

import appointmentService from "../../services/appointmentService";

const AppointmentListItemForm = (props) => {
  const [attorneys, setAttorneys] = useState([]);
  const [litigants, setLitigants] = useState([]);

  //console.log(props);

  useEffect(() => {
    let renamedArray = props.attorneys.map((a) => {
      return {
        name: a.lastName + ", " + a.firstName,
        value: a.id,
        att: { ...a },
      };
    });
    renamedArray.unshift({
      name: "Unassigned",
      value: "0",
      att: {},
    });
    setAttorneys(renamedArray);
  }, [props]);

  useEffect(() => {
    let renamedArray = props.litigants.map((a) => {
      return {
        name: a.lastName + ", " + a.firstName,
        value: a.id,
        lit: { ...a },
      };
    });
    renamedArray.unshift({
      name: "Unassigned",
      value: "0",
      lit: {},
    });
    setLitigants(renamedArray);
  }, [props]);

  const renderStatus = () => {
    if (props.deleted) return "Deleted";
    switch (props.appointmentStatus) {
      case 1:
        return "Accepted by attorney";
      case 2:
        return "Assigned to litigant";
      case 3:
        return "Appointment completed";
      default:
        return "New unassigned";
    }
  };

  const getTextColor = () => {
    //console.log(status, deleted);
    return {
      color: props.deleted
        ? "#d9534f"
        : props.appointmentStatus === 0
        ? "#292b2c"
        : props.appointmentStatus === 1
        ? "#5bc0de"
        : props.appointmentStatus === 2
        ? "#0275d8"
        : "#5cb85c", //3
    };
  };

  const renderAttorney = (props, option, snapshot, className) => {
    //console.log(props);
    return (
      <button {...props} className={className}>
        <div
          style={{
            width: "100%",
          }}
        >
          <div className="topOption">{option.name}</div>
          <div className="bottomOption">
            Bar number: {option.att.barNumber} <b>|</b> Phone:{" "}
            {option.att.phoneNumber}
          </div>
        </div>
      </button>
    );
  };

  const renderLitigant = (props, option, snapshot, className) => {
    //console.log(props);
    return (
      <button {...props} className={className}>
        <div
          style={{
            width: "100%",
          }}
        >
          <div className="topOption">{option.name}</div>
          <div className="bottomOption">
            DOB: <i>{moment(option.lit.dob).format("MM/DD/YYYY")}</i> <b>|</b>{" "}
            Email: <i>{option.lit.userName}</i> <b>|</b> Phone:{" "}
            <i>{option.lit.phoneNumber}</i>
          </div>
        </div>
      </button>
    );
  };

  const changeAttorney = (id) => {
    const apptId = { userId: id, appointmentId: props.appointmentId };
    appointmentService
      .setAppointmentAttorney(apptId)
      .then(() => props.refreshMonth());
  };

  const changeLitigant = (id) => {
    //console.log(id);
    const apptId = { userId: id, appointmentId: props.appointmentId };
    appointmentService
      .setAppointmentLitigant(apptId)
      .then(() => props.refreshMonth());
  };

  const sendQuestionnaire = () => {
    const apptId = { userId: props.user, appointmentId: props.appointmentId };
    appointmentService.sendAttorneyQuestionnaire(apptId);
  };
  const sendReminder = () => {
    const apptId = { userId: props.user, appointmentId: props.appointmentId };
    appointmentService.sendLitigantReminder(apptId);
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Row>
            <Col xs={2}>Status</Col>
            <Col xs={10}>
              <span style={{ ...getTextColor() }}>{renderStatus()}</span>
            </Col>
          </Row>
          <Row>
            <Col xs={2}>Attorney</Col>
            <Col
              xs={10}
              style={{
                padding: "2px 0px",
              }}
            >
              <SelectSearch
                options={attorneys}
                value={props.attorney}
                renderOption={renderAttorney}
                search={true}
                name="attorney"
                placeholder="Choose an attorney"
                onChange={(id) => changeAttorney(id)}
                disabled={
                  props.deleted === true
                    ? true
                    : moment().isAfter(moment(props.timeSlotStart))
                    ? true
                    : false
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={2}>Litigant</Col>
            <Col
              xs={10}
              style={{
                padding: "2px 0px",
              }}
            >
              <SelectSearch
                options={litigants}
                value={props.user}
                renderOption={renderLitigant}
                search={true}
                name="litigant"
                placeholder="Choose a litigant"
                onChange={(id) => changeLitigant(id)}
                disabled={
                  props.deleted === true
                    ? true
                    : moment().isAfter(moment(props.timeSlotStart))
                    ? true
                    : false
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={2}>Litigant</Col>
            <Col
              xs={10}
              style={{
                padding: "2px 0px",
              }}
            >
              <Button onClick={() => sendQuestionnaire()}>
                Send attorney questionnaire
              </Button>{" "}
              <Button onClick={() => sendReminder()}>
                Send litigant reminder
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AppointmentListItemForm;
